import selectors from '../../../rootSelectors';
import { LN } from '../../../constants/measure';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { goToStartPage, goToQuestion } from '../../../common/navigation/navigationActions';
import { blockScreen, unblockScreen } from '../../../common/screen/screenActions';
import { narrateStart } from '../../../common/audio/audioActions';
import { resetQuestionsAndTimeTrackingState } from '../../../common/questions/questionsActions';
import { saveLNMeasureResponse } from '../../../common/api/dnoActions';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';

export const onResponseSelect = (response, questionIndex) => (dispatch, getStore) => {
    const state = getStore();
    const isLastQuestion = (
        questionIndex === selectors.getLNTotalQuestions(state)
    );
    dispatch(blockScreen());

    return dispatch(saveLNMeasureResponse(response, questionIndex, isLastQuestion))
        .then(() => {
            if (isLastQuestion) {
                dispatch(goToStartPage());
            } else {
                dispatch(resetQuestionsAndTimeTrackingState());
                dispatch(goToQuestion(LN.ASSESSMENT, null, questionIndex + 1));
            }
        });
};

export const narrateScreen = (stimulusAudio, avatarAudio) => async (dispatch) => {
    dispatch(blockScreen());
    dispatch(narrateStart());
    dispatch(setAvatarInstructions(avatarAudio));
    await dispatch(playAvatarAudio(avatarAudio));
    await dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
    dispatch(unblockScreen());
};
